export const BROKER_CHARGES_DATA = "BROKER_CHARGES_DATA";
export const BROKER_CHARGES_ERROR_DATA = "BROKER_CHARGES_ERROR_DATA";
export const BROKER_CHARGES_HIDE_ERROR_DATA = "BROKER_CHARGES_HIDE_ERROR_DATA";
export const BROKER_CHARGES_START_LOADER = "BROKER_CHARGES_START_LOADER";
export const BROKER_CHARGES_STOP_LOADER = "BROKER_CHARGES_STOP_LOADER";
